import * as React from 'react';
import { Link } from 'theme-ui';
import { Box } from '../../ui';

export type Price = {
  id: string;
  productionId: string;
  stagingId: string;
  billingPeriod: 'once' | 'monthly' | 'quarterly' | 'yearly';
  title: string;
  heading: string;
  subheading?: string;
  isPopular?: boolean;
  description: string;
  price: number;
  period: string;
  features: React.ReactNode[];
  buttonText: string;
  buttonInfoText: string;
};

const PRICES: { [id: string]: Price } = {
  'once-19': {
    id: 'once-19',
    productionId: 'price_1HdKoYLMvnWg3hHqsTNPe3xS',
    stagingId: 'price_1Hd0N0LMvnWg3hHqZJcxSnzP',
    billingPeriod: 'once',
    title: 'Recruited',
    heading: '$19 billed once',
    description:
      'Is someone waiting for your resume? Download it now and schedule the interview.',
    price: 19,
    period: 'for 24 hours',
    features: [
      'Resume score and suggestions',
      'Unlimited PDF downloads',
      'One time payment',
    ],
    buttonText: 'Buy now',
    buttonInfoText: 'Get $19 credit if you upgrade your plan within 7 days.',
  },
  'monthly-5': {
    id: 'monthly-5',
    productionId: 'price_1Lf90bLMvnWg3hHqymf6zXm4',
    stagingId: 'price_1Lf8tzLMvnWg3hHqYzO1NJNv',
    billingPeriod: 'monthly',
    title: '',
    heading: '$5 billed monthly',
    description: '',
    price: 5,
    period: 'Billed monthly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: '',
  },
  'monthly-9': {
    id: 'monthly-9',
    productionId: 'price_1Lf911LMvnWg3hHq0VO33mAY',
    stagingId: 'price_1Lf8vBLMvnWg3hHq2Az1jilB',
    billingPeriod: 'monthly',
    title: '',
    heading: '$9 billed monthly',
    description: '',
    price: 9,
    period: 'Billed monthly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: '',
  },
  'monthly-19': {
    id: 'monthly-19',
    productionId: 'price_1Hna0ILMvnWg3hHqax3G2Q3D',
    stagingId: 'price_1Hna1ALMvnWg3hHqUMsrMMsD',
    billingPeriod: 'monthly',
    title: 'Recruited',
    heading: '$19 billed monthly',
    description:
      'Is someone waiting for your resume? Download it now and schedule the interview.',
    price: 19,
    period: 'Billed monthly',
    features: [
      'Resume review with suggestions',
      'Unlimited PDF downloads',
      'Application specific resumes',
    ],
    buttonText: 'Subscribe',
    buttonInfoText: 'Cancel anytime. 30 day money-back guarantee.',
  },
  'quarterly-9': {
    id: 'quarterly-9',
    productionId: 'price_1Lf91NLMvnWg3hHqdnIfGrvQ',
    stagingId: 'price_1Lf8vZLMvnWg3hHqn3jgK0S4',
    billingPeriod: 'quarterly',
    title: '',
    heading: '$9 billed quarterly',
    subheading: 'Only $3/month',
    isPopular: true,
    description: '',
    price: 9,
    period: 'Billed quarterly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: '',
  },
  'quarterly-14': {
    id: 'quarterly-14',
    productionId: 'price_1Lf91hLMvnWg3hHq780nAmfl',
    stagingId: 'price_1Lf8vuLMvnWg3hHq7ObfvKf0',
    billingPeriod: 'quarterly',
    title: '',
    heading: '$14 billed quarterly',
    subheading: 'Only $4.66/month',
    isPopular: true,
    description: '',
    price: 14,
    period: 'Billed quarterly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: '',
  },
  'quarterly-29': {
    id: 'quarterly-29',
    productionId: 'price_1HdKp0LMvnWg3hHqk277z8BF',
    stagingId: 'price_1Hd0MTLMvnWg3hHqeEHriEc1',
    billingPeriod: 'quarterly',
    title: 'Job Seeker',
    heading: '$29 billed quarterly',
    subheading: 'Only $9.66/month',
    isPopular: true,
    description:
      'Most job searches last months. Everything you need to optimize each application.',
    price: 29,
    period: 'Billed quarterly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: 'Cancel anytime. 30 day money-back guarantee.',
  },
  'yearly-19': {
    id: 'yearly-19',
    productionId: 'price_1Lf926LMvnWg3hHq6pRldrjs',
    stagingId: 'price_1Lf8wHLMvnWg3hHqgDv0e6Im',
    billingPeriod: 'yearly',
    title: '',
    heading: '$19 billed yearly',
    subheading: 'Only $1.58/month',
    description: '',
    price: 19,
    period: 'Billed yearly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: '',
  },
  'yearly-29': {
    id: 'yearly-29',
    productionId: 'price_1Lf92WLMvnWg3hHqYu8rAvI6',
    stagingId: 'price_1Lf8wgLMvnWg3hHqM4935dgP',
    billingPeriod: 'yearly',
    title: '',
    heading: '$29 billed yearly',
    subheading: 'Only $2.42/month',
    description: '',
    price: 29,
    period: 'Billed yearly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: '',
  },
  'yearly-69': {
    id: 'yearly-69',
    productionId: 'price_1HdKpfLMvnWg3hHqsRax95XH',
    stagingId: 'price_1Hd0LELMvnWg3hHqLkUDpjBH',
    billingPeriod: 'yearly',
    title: 'Freelancer',
    heading: '$69 billed yearly',
    subheading: 'Only $5.75/month',
    description:
      'Build an online presence with everything you need to keep your professional brand up to date.',
    price: 69,
    period: 'Billed yearly',
    features: [],
    buttonText: 'Subscribe',
    buttonInfoText: 'Cancel anytime. 30 day money-back guarantee.',
  },
};

export default PRICES;
